var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolStatsPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5829 10.7866H19.5829V4.78662H20.5829V2.78662H4.58289V4.78662H5.58289V10.7866H3.58289C3.31767 10.7866 3.06332 10.892 2.87578 11.0795C2.68824 11.2671 2.58289 11.5214 2.58289 11.7866V20.7866H22.5829V11.7866C22.5829 11.5214 22.4775 11.2671 22.29 11.0795C22.1025 10.892 21.8481 10.7866 21.5829 10.7866ZM14.5829 18.7866V14.7866H10.5829V18.7866H7.58289V4.78662H17.5829V18.7866H14.5829Z",
    fill: "#FF5500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58289 6.78662H11.5829V8.78662H9.58289V6.78662ZM13.5829 6.78662H15.5829V8.78662H13.5829V6.78662ZM9.58289 10.7866H11.5829V12.7866H9.58289V10.7866ZM13.5829 10.7866H15.5829V12.7866H13.5829V10.7866Z",
    fill: "#FF5500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolStatsPending);
export default __webpack_public_path__ + "static/media/schoolStatsPending.45c0dc46ba44be897f35f4b02560fa8b.svg";
export { ForwardRef as ReactComponent };